import React, { createContext, useContext, useState } from "react";
import CustomAlert from "../components/CustomAlert";

interface AlertContextType {
  triggerAlert: (
    message: string,
    type: "success" | "error",
    duration: number
  ) => void;
}

const AlertContext = createContext<AlertContextType | undefined>(undefined);

export const AlertProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [alert, setAlert] = useState<{
    message: string;
    type: "success" | "error";
    duration: number;
  } | null>(null);

  const triggerAlert = (
    message: string,
    type: "success" | "error",
    duration: number
  ) => {
    setAlert({ message, type, duration });
    setTimeout(() => setAlert(null), duration);
  };

  return (
    <AlertContext.Provider value={{ triggerAlert }}>
      {children}
      {alert && (
        <CustomAlert
          message={alert.message}
          type={alert.type}
          duration={alert.duration}
        />
      )}
    </AlertContext.Provider>
  );
};

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error("useAlert must be used within an AlertProvider");
  }
  return context;
};
